







































import Vue from 'vue'
import _ from 'lodash'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { GridOptions } from 'ag-grid-community'
import BooleanCellRenderer from '@/components/cell-renderer/BooleanCellRenderer.vue'
import { EmployeeAvailableForPlanning } from '@/model/planning/EmployeeAvailableForPlanning'
import {
  ABSENCES_ASSISTANT_GET_EMPLOYEE_LIST_FOR_PLANNING, ABSENCES_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST,
  ABSENCES_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST
} from '@/store/getter-types'
import { SelectedEmployee } from '@/model/absences/SelectedEmployee'
import { hexToRgba } from '@/services/hex-to-rgba'
import ProgressCircular from '@/components/ProgressCircular.vue'

interface ComponentData {
  disabledSave: boolean
  gridOptions: GridOptions
  gridApi: any
  gridFrameworkComponents: Object
  selectedEmployeeList: Array<EmployeeAvailableForPlanning>
  overlayNoRowsTemplate: string
  searchEmployee: string | null
}

export default Vue.extend({
  name: 'AbsencesEditorEmployeeSelectorDialog',

  components: {
    AgGridVue,
    ProgressCircular
  },

  props: {
    show: Boolean,
    title: String,
    rowSelection: String,
    periodicitySelectedRow: String,
    loading: {
      type: Boolean,
      default: false
    }
  },

  data (): ComponentData {
    return {
      disabledSave: true,
      gridOptions: {
        columnDefs: [
          { headerName: this.$t('absencesPage.name').toString(), field: '', width: 50, checkboxSelection: true },
          { headerName: this.$t('absencesPage.name').toString(), field: 'name', width: 250, sort: 'asc' },
          { headerName: this.$t('absencesPage.capacity').toString(), field: 'capacity', width: 150 },
          { headerName: this.$t('absencesPage.jumper').toString(), field: 'isFloater', width: 120, cellRenderer: 'booleanRenderer'},
          { headerName: this.$t('absencesPage.planningGroup').toString(), field: 'planingGroupName' }
        ],
      },
      gridApi: null,
      gridFrameworkComponents: {
        booleanRenderer: BooleanCellRenderer
      },

      selectedEmployeeList: [],
      overlayNoRowsTemplate: "<span>"+this.$t('errors.noRowsToShow')+"</span>",
      searchEmployee: null
    }
  },

  watch: {
    searchEmployee (newVal: string | null): void {
      this.gridApi.onFilterChanged()
    }
  },

  computed: {
    employeeList (): EmployeeAvailableForPlanning[] {
      const availableEmployeeList: EmployeeAvailableForPlanning[] = this.$store.getters[ABSENCES_ASSISTANT_GET_EMPLOYEE_LIST_FOR_PLANNING]
      const plannedEmployeeList: SelectedEmployee[] = this.$store.getters[ABSENCES_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST]
      const periodicityPlannedEmployeeList: any[] = this.$store.getters[ABSENCES_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST]

      if (!this.periodicitySelectedRow) {
        // Normal

        return availableEmployeeList.filter((item: EmployeeAvailableForPlanning) => {
          return !_.find(plannedEmployeeList, { id: item.id })
        })
      } else {
        // Periodicity

        return availableEmployeeList.filter((item: EmployeeAvailableForPlanning) => {
          return !_.find(periodicityPlannedEmployeeList[parseInt(this.periodicitySelectedRow)].employeeList, { id: item.id })
        })
      }
    },

    saveButton (): boolean {
      return this.disabledSave
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },
  },

  methods: {
    onGridReady(params: any): void {
      this.gridApi = params.api
    },

    isExternalFilterPresent(): boolean {
      return this.searchEmployee !== null
    },

    doesExternalFilterPass(node: any): boolean {
      if(this.searchEmployee) {
        return node.data.name.toLocaleLowerCase().includes(this.searchEmployee.toLocaleLowerCase())
      } else {
        return true
      }
    },

    onCloseButtonClick (): void {
      this.disabledSave = true
      // @ts-ignore
      this.gridOptions.api.forEachNode((node) => {
        node.setSelected(false)
      })
      this.$emit('close')
    },

    onCancelButtonClick (): void {
      this.disabledSave = true
      // @ts-ignore
      this.gridOptions.api.forEachNode((node) => {
        node.setSelected(false)
      })
      this.$emit('close')
    },

    onSaveButtonClick (): void {
      this.disabledSave = true
      this.$emit('employeeListSelected', this.selectedEmployeeList)
    },

    onRowSelectionChange(grid: any): void {
      // @ts-ignore
      this.selectedEmployeeList = grid.api.getSelectedNodes().map(i => i.data)
      this.disabledSave = this.selectedEmployeeList.length === 0
    }
  },

  mounted (): void {
    setTimeout(() => {
      const searchField: any = this.$refs['searchField']
      if (searchField) {
        searchField.focus()
      }
    })
  }
})
